import React, { Component } from 'react'
import PropTypes from 'prop-types'
import '../styles/video.css'

class Video extends Component {
  openCloseVideo (videoID, videoContainerID, videoOverlayID) {
    if (this.props.active !== true) {
      return
    }
    const video = document.getElementById(videoID)
    const videoContainer = document.getElementById(videoContainerID)
    const videoOverlay = document.getElementById(videoOverlayID)

    if (video.muted === true) {
      document.getElementById('navButton').style.display = 'none'
      video.muted = false
      video.curruntTime = 0
      video.load()
      videoContainer.classList.add('cinematic')
      videoOverlay.style.display = 'block'
      setTimeout(function () {
        videoOverlay.classList.add('cinematic')
      }, 0)
      window.addEventListener('DOMMouseScroll', this.lockScroll, false)
      window.onwheel = this.lockScroll
      window.onmousewheel = document.onmousewheel = this.lockScroll
      window.ontouchmove = this.lockScroll
      document.onkeydown = this.lockScrollKeys
    } else {
      document.getElementById('navButton').style.display = 'inline-block'
      video.muted = true
      videoContainer.classList.remove('cinematic')
      videoOverlay.classList.remove('cinematic')
      setTimeout(function () {
        videoOverlay.style.display = 'none'
      }, 300)
      window.removeEventListener('DOMMouseScroll', this.lockScroll, false)
      window.onmousewheel = document.onmousewheel = null
      window.onwheel = null
      window.ontouchmove = null
      document.onkeydown = null
    }
  }
  lockScrollKeys (e) {
    const keys = {37: 1, 38: 1, 39: 1, 40: 1}
    if (keys[e.keyCode]) {
      e.preventDefault()
      return false
    }
  }
  lockScroll (e) {
    e = e || window.event
    if (e.preventDefault) {
      e.preventDefault()
    }
    e.returnValue = false
  }
  seekVideo (videoID, seekBarID, seekProgressID) {
    const video = document.getElementById(videoID)
    const seekBar = document.getElementById(seekBarID)
    const seekProgress = document.getElementById(seekProgressID)
    const time = video.duration * (seekBar.value / 100)
    video.currentTime = time
    seekProgress.style.width = seekBar.value + '%'
  }
  timeUpdate (videoID, seekBarID, seekProgressID) {
    const video = document.getElementById(videoID)
    const seekBar = document.getElementById(seekBarID)
    const seekProgress = document.getElementById(seekProgressID)
    var value = (100 / video.duration) * video.currentTime
    seekBar.value = value
    seekProgress.style.width = seekBar.value + '%'
  }
  scrubVideoPause (videoID) {
    const video = document.getElementById(videoID)
    video.pause()
  }
  scrubVideoPlay (videoID) {
    const video = document.getElementById(videoID)
    video.play()
  }
  render () {
    return (
      <div className='videoContainer' id={this.props.options.video + '_container'}>
        <div className='videoCard' id={this.props.options.video + '_card'}
          style={{backgroundImage: 'url("' + this.props.options.video + '.jpg")'}}
          onClick={() => this.openCloseVideo(this.props.options.video + '_video', this.props.options.video + '_container', this.props.options.video + '_overlay')}>
          <div className='video'>
            <video loop autoPlay muted playsInline poster={this.props.options.video + '.jpg'}
              id={this.props.options.video + '_video'}
              onTimeUpdate={() => this.timeUpdate(this.props.options.video + '_video', this.props.options.video + '_seekInput', this.props.options.video + '_seekProgress')}>
              <source src={this.props.options.video + '.mp4'} type='video/mp4' />
              <source src={this.props.options.video + '.webm'} type='video/webm' />
              <source src={this.props.options.video + '.ogv'} type='video/ogg' />
            </video>
          </div>
        </div>
        <div className='videoSeek'>
          <div className='seekProgress' id={this.props.options.video + '_seekProgress'} />
          <div className='seekBar' id={this.props.options.video + '_seekBar'} />
          <input type='range' id={this.props.options.video + '_seekInput'}
            onMouseDown={() => this.scrubVideoPause(this.props.options.video + '_video')}
            onMouseUp={() => this.scrubVideoPlay(this.props.options.video + '_video')}
            onChange={() => this.seekVideo(this.props.options.video + '_video', this.props.options.video + '_seekInput', this.props.options.video + '_seekProgress')} />
        </div>
        <div className='videoOverlay'
          id={this.props.options.video + '_overlay'}
          onClick={() => this.openCloseVideo(this.props.options.video + '_video', this.props.options.video + '_container', this.props.options.video + '_overlay')} />
      </div>
    )
  }
}

Video.propTypes = {
  options: PropTypes.object.isRequired,
  active: PropTypes.bool
}

export default Video



// WEBPACK FOOTER //
// ./src/components/Video.js